import { render, staticRenderFns } from "./SuccessPage.vue?vue&type=template&id=06fc29fb&scoped=true&"
import script from "./SuccessPage.vue?vue&type=script&lang=ts&"
export * from "./SuccessPage.vue?vue&type=script&lang=ts&"
import style0 from "./SuccessPage.vue?vue&type=style&index=0&id=06fc29fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fc29fb",
  null
  
)

export default component.exports